import { createContext, useContext } from 'react';
import { Validable } from '.';

export const ValidableContext = createContext<Validable<any> | undefined>(
  undefined,
);

export function useValidableContext<T extends object>() {
  const context = useContext<Validable<T> | undefined>(ValidableContext);
  return context;
}
